import React from "react";
import {
  CCol,
  CFormGroup,
  CLabel,
  CRow,
  CSelect,
  CTextarea,
} from "@coreui/react";
import { getFieldErrors } from "../../../models/errors";
import { FieldErrors } from "../../form/FieldErrors";
import { CURRENCY_CHOICES, PYG } from "../../../currency/available-currencies";
import PYGField from "../../currencies/PYGField";
import { useDebitNoteFormContext } from "../context/DebitNoteFormContext";

const SectionDivider: React.FC<{ icon: string; label: string }> = ({ icon, label }) => (
  <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", marginTop: "16px" }}>
    <div style={{ width: "4px", height: "18px", background: "#006657", borderRadius: "2px", marginRight: "10px", flexShrink: 0 }} />
    <i className={`fa ${icon} mr-2`} style={{ fontSize: "0.85rem", color: "var(--theme-accent)" }}></i>
    <h6 style={{ margin: 0, fontWeight: 600, color: "var(--theme-muted)", fontSize: "0.78rem", textTransform: "uppercase", letterSpacing: "0.8px" }}>
      {label}
    </h6>
    <div style={{ flex: 1, height: "1px", background: "var(--theme-divider)", marginLeft: "10px" }} />
  </div>
);

const FormLabel: React.FC<{ required?: boolean; children: React.ReactNode }> = ({ required, children }) => (
  <CLabel className="mb-0" style={{ fontWeight: 600, fontSize: "0.875rem", color: "var(--theme-text-soft)" }}>
    {required && <span className="text-danger mr-1">*</span>}
    {children}
  </CLabel>
);

export const DebitNoteFormDetailsSection: React.FC = () => {
  const {
    debitNoteRef,
    currency,
    pygExchangeRate,
    onCurrencyChange,
    onPygExchangeRateChange,
    onObsChange,
    errors,
    readonly,
  } = useDebitNoteFormContext();

  const debitNote = debitNoteRef.current;

  return (
    <>
      <SectionDivider icon="fa-exchange" label="Detalles" />
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel>Moneda:</FormLabel>
          </CCol>
          <CCol md={2}>
            <CSelect
              type="text"
              defaultValue={debitNote !== null ? debitNote.currency : PYG}
              onChange={onCurrencyChange}
              disabled={readonly}
            >
              <option value={""} disabled>
                -----
              </option>
              {Array.from(CURRENCY_CHOICES.entries()).map((entry) => {
                return (
                  <option key={entry[0]} value={entry[0]}>
                    {entry[1]}
                  </option>
                );
              })}
            </CSelect>
            <FieldErrors
              errors={getFieldErrors("currency", errors) as string[]}
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
      {currency !== PYG ? (
        <CFormGroup>
          <CRow className="align-items-center">
            <CCol md={2}>
              <FormLabel required>Cambio:</FormLabel>
            </CCol>
            <CCol md={2}>
              <PYGField
                placeholder="Total"
                limit={1000000000000}
                onChange={onPygExchangeRateChange}
                value={pygExchangeRate}
              />
              <FieldErrors
                errors={getFieldErrors("pygExchangeRate", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
      ) : null}
      <CFormGroup>
        <CRow className="align-items-center">
          <CCol md={2}>
            <FormLabel>Observación:</FormLabel>
          </CCol>
          <CCol md={10}>
            <CTextarea
              placeholder="Información adicional"
              defaultValue={debitNote !== null ? debitNote.obs : undefined}
              onChange={onObsChange}
              disabled={readonly}
              style={{ resize: "vertical", minHeight: "70px" }}
            ></CTextarea>
            <FieldErrors
              errors={getFieldErrors("obs", errors) as string[]}
            ></FieldErrors>
          </CCol>
        </CRow>
      </CFormGroup>
    </>
  );
};
